<template>
<div class="container">
<b-row v-if="!isLoading">
<b-container>
	<h4>
	<label>País</label>
	<select v-model="pais" @click="f_carga_facturas()">
		<option
			v-for="(item, idx) in listPaises"
			:key="idx"
			:value="item.pais">
			{{item.pais}}
		</option>
	</select>
	</h4>
</b-container>
<md-dialog :md-active.sync="fgl_muestraProveedores">
	<md-dialog-title class="text-center">
		<h3><b><i>Contabilizacion Manual de Facturas</i></b> </h3>
	</md-dialog-title>
	<md-dialog-content>
		<md-table v-model="listFacturas" md-card md-fixed-header @md-selected="f_selecciona_facturas">
		<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
			<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
			<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.razon_social}}</md-table-cell>
			<md-table-cell :md-label="labels.facturas" class="text-left border">{{item.cuantos}}</md-table-cell>
		</md-table-row>
		</md-table>
	</md-dialog-content>
</md-dialog>
<md-dialog :md-active.sync="fgl_muestraDetalle">
	<md-dialog-title class="text-center">
		<h3><b><i>Contabilizacion Manual de Facturas</i></b> </h3>
	</md-dialog-title>
	<md-dialog-content>
		<md-table v-model="listFacturasProveedor" md-card md-fixed-header @md-selected="f_valida_factura">
		<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
			<md-table-cell  :md-label="labels.fecha" class="text-left border">{{item.fecha}}</md-table-cell>
			<md-table-cell  :md-label="labels.documento" class="text-left border">{{item.tipo_cp}}</md-table-cell>
			<md-table-cell  :md-label="labels.factura" class="text-left border">{{item.factura}}</md-table-cell>
			<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
			<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.razon_social}}</md-table-cell>
		</md-table-row>
		</md-table>
		<md-dialog-actions>
			<md-button class="md-accent" @click="fgl_muestraDetalle=false;fgl_muestraProveedores=true">Regresar</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
<md-dialog :md-active.sync="muestreDetalleFactura">
	<md-dialog-title class="text-center">
		<h3><b><i>Contabilizacion Manual de Facturas</i></b> </h3>
	</md-dialog-title>
	<md-dialog-content>
		<md-table >
			<md-table-row >
				<md-table-cell class="text-right border"><h5>Documento</h5></md-table-cell>
				<md-table-cell><h5>{{factura.documento}}</h5></md-table-cell>
				<md-table-cell><h5>{{factura.factura}}</h5></md-table-cell>
				<md-table-cell><h5>{{factura.identificacion}}</h5></md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border"><h5>Fecha/Nombre</h5></md-table-cell>
				<md-table-cell class="text-left border">
					<h5>{{f_formato_fecha(factura.fecha_factura)}}</h5>
				</md-table-cell>
				<md-table-cell colspan="2" class="text-left border">
					<h5>{{factura.nombre}}</h5>
				</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border"><h5>Orden de Compra</h5></md-table-cell>
				<md-table-cell class="text-left border">
					<md-field><md-input v-model="factura.pedido" placeholder="Orden de Compra"></md-input></md-field>
				</md-table-cell>
				<md-table-cell class="text-right border"><h5>Doc Relacionado</h5></md-table-cell>
				<md-table-cell class="text-left border">
					<md-field><md-input v-model="factura.remision" placeholder="Doc Relacionado"></md-input></md-field>
				</md-table-cell>
			</md-table-row>
			<md-table-row>
				<md-table-cell class="text-right border"><h5>Impuesto(s)</h5></md-table-cell>

				<md-table-cell class="text-left border">
					<md-field><md-input v-model="factura.categoria0" placeholder="Clase"></md-input></md-field>
					<md-field><md-input v-model="factura.impuesto0" placeholder="Impuesto"></md-input></md-field>
				</md-table-cell>
				<md-table-cell class="text-left border">
					<md-field><md-input v-model="factura.categoria1" placeholder="Clase"></md-input></md-field>
					<md-field><md-input v-model="factura.impuesto1" placeholder="Impuesto"></md-input></md-field>
				</md-table-cell>
				<md-table-cell class="text-left border">
					<md-field><md-input v-model="factura.categoria2" placeholder="Clase"></md-input></md-field>
					<md-field><md-input v-model="factura.impuesto2" placeholder="Impuesto"></md-input></md-field>
				</md-table-cell>
			</md-table-row>
			<md-table-row>
				<md-table-cell class="text-right border"></md-table-cell>

				<md-table-cell class="text-left border">
					<md-field><md-input v-model="factura.categoria3" placeholder="Clase"></md-input></md-field>
					<md-field><md-input v-model="factura.impuesto3" placeholder="Impuesto"></md-input></md-field>
				</md-table-cell>
				<md-table-cell class="text-left border">
					<md-field><md-input v-model="factura.categoria4" placeholder="Clase"></md-input></md-field>
					<md-field><md-input v-model="factura.impuesto4" placeholder="Impuesto"></md-input></md-field>
				</md-table-cell>
				<md-table-cell class="text-left border">
					<md-field><md-input v-model="factura.categoria5" placeholder="Clase"></md-input></md-field>
					<md-field><md-input v-model="factura.impuesto5" placeholder="Impuesto"></md-input></md-field>
				</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border"><h5>Valor</h5></md-table-cell>

				<md-table-cell class="text-left border"><h5>{{factura.valor}}</h5></md-table-cell>
				<md-table-cell class="text-right border"><h5>Total Impuestos</h5></md-table-cell>
				<md-table-cell class="text-left border"><h5>{{factura.impuesto_total}}</h5></md-table-cell>
			</md-table-row>
			<md-table-row >

				<md-table-cell class="text-left border"></md-table-cell>
				<md-table-cell class="text-right border"></md-table-cell>
				<md-table-cell class="text-right border"><h5>Total Factura</h5></md-table-cell>
				<md-table-cell class="text-left border"><h5>{{factura.valor_total}}</h5></md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border"><h5>Lider</h5></md-table-cell>
				<md-table-cell class="text-left border">{{f_usuario_nombre(factura.id_lider)}}</md-table-cell>
				<md-table-cell class="text-right border"><h5>Usuario</h5></md-table-cell>
				<md-table-cell class="text-left border">{{f_usuario_nombre(factura.id_usuario)}}</md-table-cell>
			</md-table-row>
			<md-table-row >
				<md-table-cell class="text-right border"><h5>Llave</h5></md-table-cell>
				<md-table-cell class="text-left border"><h5>{{factura.llave}}</h5></md-table-cell>
				<md-table-cell class="text-right border"><h5>Detraccion</h5></md-table-cell>
				<md-table-cell class="text-left border"><h5>{{factura.detraccion}}</h5></md-table-cell>
			</md-table-row>
			<md-table-row v-if="factura.diferencia>0">
				<md-table-cell class="text-right border"><h5>Diferencia</h5></md-table-cell>
				<md-table-cell class="text-left border"><h5>{{factura.diferencia}}</h5></md-table-cell>
				<md-table-cell class="text-right border"><h5></h5></md-table-cell>
				<md-table-cell class="text-left border"><h5></h5></md-table-cell>
			</md-table-row>
		</md-table>
		<md-table>
			<md-table-row v-if="estado.observaciones || estado.contabiliza">
				<md-table-cell v-if="estado.contabiliza" class="text-left border">
					<md-field><md-input v-model="factura.documento_contable" @input="f_verifique_doc_contable(factura.documento_contable)" placeholder="Documento Contable"></md-input></md-field>
				</md-table-cell>
				<md-table-cell v-if="estado.observaciones" class="text-right border">
					<md-field><md-textarea v-model="observaciones" rows="10" cols="50" placeholder="Observaciones"></md-textarea></md-field>
				</md-table-cell>
			</md-table-row>
		</md-table>
		<md-dialog-actions>
			<select v-model="factura.razon_estado">
				<option
					v-for="(item, idx) in listRazones"
					:key="'razon-'+idx"
					:value="item.razon">
					{{item.razon}}-{{item.descripcion}}({{f_estado(item.estado)}})
				</option>
			</select>
			<md-button v-if="factura.razon_estado && !grabar" class="md-primary" @click="f_pide_adicional()">Registrar</md-button>
			<md-button v-if="factura.razon_estado && novedades" class="md-primary" @click="f_pide_novedades()">Novedades</md-button>
			<md-button v-if="factura.razon_estado && grabar" class="md-primary" @click="f_actualiza_contab(false)">Grabar</md-button>
			<md-button class="md-accent" @click="f_inicie_contab()">Regresar</md-button>
		</md-dialog-actions>
	</md-dialog-content>
</md-dialog>
</b-row>

<b-container v-if="fgl_novedades==true">
	<h3>
		<b><i>Registro de Novedades</i></b>&nbsp;&nbsp;&nbsp;&nbsp;
		<md-button class="md-primary" @click="f_adiciona_novedad()"><md-icon>add</md-icon></md-button>
	</h3>
	<md-table >
		<md-table-row >
			<md-table-cell class="text-right border"><h5>Documento</h5></md-table-cell>
			<md-table-cell class="text-right border"><h5>{{factura.documento}}</h5></md-table-cell>
			<md-table-cell class="text-right border"><h5>{{factura.factura}}</h5></md-table-cell>
			<md-table-cell class="text-right border"><h5>{{factura.identificacion}}</h5></md-table-cell>
		</md-table-row>
		<md-table-row >
			<md-table-cell class="text-right border"><h5>Fecha/Nombre</h5></md-table-cell>
			<md-table-cell class="text-left border">
				<h5>{{f_formato_fecha(factura.fecha_factura)}}</h5>
			</md-table-cell>
			<md-table-cell colspan="2" class="text-left border">
				<h5>{{factura.nombre}}</h5>
			</md-table-cell>
		</md-table-row>
	</md-table>
	<md-table v-model="novedad_detalle" md-card md-fixed-header >
	<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
		<md-table-cell :md-label="labels.item" class="text-left border">{{item.item}}</md-table-cell>
		<md-table-cell :md-label="labels.descripcion" class="text-left border">{{item.descripcion}}</md-table-cell>
		<md-table-cell :md-label="labels.cantidadFE" class="text-left border">{{item.cantidad_fe}}</md-table-cell>
		<md-table-cell :md-label="labels.precioFE" class="text-left border">{{item.precio_fe}}</md-table-cell>
		<md-table-cell :md-label="labels.ivaFE" class="text-left border">{{item.iva_fe}}</md-table-cell>
		<md-table-cell :md-label="labels.adicionalFE" class="text-left border">{{item.impuesto_adicional_fe}}</md-table-cell>
		<md-table-cell :md-label="labels.cantidadSAP" class="text-left border">{{item.cantidad_sap}}</md-table-cell>
		<md-table-cell :md-label="labels.precioSAP" class="text-left border">{{item.precio_sap}}</md-table-cell>
		<md-table-cell :md-label="labels.ivaSAP" class="text-left border">{{item.iva_sap}}</md-table-cell>
	</md-table-row>
	</md-table>
	<md-table>
		<md-table-row><h3>
			<md-buttom v-if="novedad_detalle.length>0" class="md-primary" @click="f_acepta_novedades()">Aceptar</md-buttom>&nbsp;&nbsp;&nbsp;&nbsp;
			<md-buttom class="md-primary" @click="fgl_novedades=false;muestreDetalleFactura=true">Regresar</md-buttom>
		</h3></md-table-row>
	</md-table>
	<md-table v-if="nuevaNovedad == true">
		<md-table-row>
			<md-table-cell class="text-left border">Item</md-table-cell>
			<md-table-cell class="text-left border">Descripcion</md-table-cell>
			<md-table-cell class="text-left border"></md-table-cell>
			<md-table-cell class="text-left border">Cantidad</md-table-cell>
			<md-table-cell class="text-left border">Precio</md-table-cell>
			<md-table-cell class="text-left border">Iva</md-table-cell>
			<md-table-cell class="text-left border">Adicional</md-table-cell>
		</md-table-row>
		<md-table-row>
			<md-table-cell class="text-left border">
				<md-field><md-input v-model="novedad.item" placeholder="Item"></md-input></md-field>
			</md-table-cell>
			<md-table-cell class="text-left border">
				<md-field><md-input v-model="novedad.descripcion" placeholder="Descripcion"></md-input></md-field>
			</md-table-cell>
			<md-table-cell>FE</md-table-cell>
			<md-table-cell class="text-left border">
				<md-field><md-input v-model="novedad.cantidad_fe" placeholder="Cantidad Factura"></md-input></md-field>
			</md-table-cell>
			<md-table-cell class="text-left border">
				<md-field><md-input v-model="novedad.precio_fe" placeholder="Precio Factura"></md-input></md-field>
			</md-table-cell>
			<md-table-cell class="text-left border">
				<md-field><md-input v-model="novedad.iva_fe" placeholder="Iva Factura"></md-input></md-field>
			</md-table-cell>
			<md-table-cell class="text-left border">
				<md-field><md-input v-model="novedad.impuesto_adicional_fe" placeholder="Impuesto Adicional Factura"></md-input></md-field>
			</md-table-cell>
		</md-table-row>
		<md-table-row>
			<md-table-cell class="text-left border"></md-table-cell>
			<md-table-cell class="text-left border"></md-table-cell>
			<md-table-cell class="text-left border">SAP</md-table-cell>
			<md-table-cell class="text-left border">
				<md-field><md-input v-model="novedad.cantidad_sap" placeholder="Cantidad SAP"></md-input></md-field>
			</md-table-cell>
			<md-table-cell class="text-left border">
				<md-field><md-input v-model="novedad.precio_sap" placeholder="Precio SAP"></md-input></md-field>
			</md-table-cell>
			<md-table-cell class="text-left border">
				<md-field><md-input v-model="novedad.iva_sap" placeholder="Iva SAP"></md-input></md-field>
			</md-table-cell>
			<md-table-cell class="text-left border"></md-table-cell>
		</md-table-row>
	</md-table>
	<md-table v-if="nuevaNovedad == true">
		<md-table-row><h3>
			<md-buttom class="md-primary" @click="f_agrega_novedad()">Aceptar</md-buttom>&nbsp;&nbsp;&nbsp;&nbsp;
			<md-buttom class="md-primary" @click="novedad={};nuevaNovedad=false">Regresar</md-buttom>
		</h3></md-table-row>
	</md-table>
</b-container>
</div>
</template>
<script>
import Factura from "@/services/Facturas"
import Lider from "@/services/Lideres"
import User from "@/services/User"
import Razon from "@/services/Razones"
import Estado from "@/services/Estados"

export default {
name:'Manual',
data: () => ({
	valores:true,
	isLoading: false,
	selecciona: false,
	fgl_asignar: false,
	fgl_asignaAutomatica: false,
	fgl_novedad: false,
	fgl_adicionar_diferencias: false,
	fgl_muestraDetalle: false,
	fgl_muestraProveedores: false,
	adicional: false,
	grabar: false,
	novedades: false,
	fgl_novedades: false,
	nuevaNovedad: false,
	opcion: 2,
	diferencias: 0,
	noHomologados:0,
	homologados: 0,
	factura: {},
	relacionado: '',
	estado: '',
	observaciones: '',
	pais: '',
	usuario: '',
	idLider: '',
	titulo_factura: "",
	users : [],
	listPaises : [],
	listNovedades : [],
	listLiderUsuarios : [],
	asignaUsuario: [],
	muestreFacturas: false,
	muestreDetalleFactura: false,
	contabilizaFactura: false,
	muestreLiderUsuarios: false,
	listRazones : [],
	listRazonesLeidas : [],
	listEstados : [],
	novedad: {},
	novedad_item: {},
	novedad_detalle: [],
	valor_total_fe : 0,
	valor_total_sap : 0,
	listControl: {},
	reg_factura: {},
	listFacturasG: [],
	listFacturas: [],
	listFacturasProveedor: [],
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			title : "FACTURAS",
			documento : "Tipo",
			factura : "Número Factura",
			fecha : "Fecha Factura",
			identificacion : "Número Identificación",
			proveedor : "Nombre del Proveedor",
			cantidad_facturas : "Facturas",
			pedido : "Número Pedido",
			valor : "Valor Bruto",
			impuesto0 : "Impuesto0",
			categoria0 : "Categoria0",
			impuesto1 : "Impuesto1",
			categoria1 : "Categoria1",
			impuesto2 : "Impuesto2",
			categoria2 : "Categoria2",
			impuesto_tot : "Total Impuesto",
			valor_total : "Total Factura",
			items : "Items",
			item : "Item",
			descripcion : "Descripcion",
			precioFE : "PrecioFE",
			precioSAP : "PrecioSAP",
			cantidadFE : "CantFE",
			cantidadSAP : "CantSAP",
			ivaFE : "IvaFE",
			adicionalFE : "AdicionalFE",
			ivaSAP : "IvaSAP",
			impuestoFE : "ImpFE",
			impuestoSAP : "ImpSAP",
			diferencia_total : "DifTotal",
			valor_fe : "TotalFE",
			valor_sap : "TotalSAP",
			usuario : "Usuario",
			cantidad: "Cantidad",
			codigo: "Codido",
			descripcion_item: "Descripcion Producto --------------------------------",
			descripcion_item_orden: "Descripcion Orden Compra ----------------------------------------------",
			descripcion_novedad: "Descripcion ----------------------------------------------------------------------------------------",
			unidad: "UnEmpa",
			unitario: "Monto",
			venta_bruta: "Precio Ord",
			venta_bruta_factura: "Precio Fac",
			item_factura: "Item Fac",
			impuesto: "Impuesto",
			cantidad_facturada: "Cant Fac",
			precio_facturado: "Precio Fac",
			valoresQ: "Q SAP",
			valoresP: "P SAP",
			diferenciasQ: "DIFER Q",
			diferenciasP: "DIFER P",
			monto_facturado: "Monto Fac",
			iva: "IGV",
			otroImpuesto : "Imp Adic"
		}
	}else{
		return {
			title : "INVOICES",
			factura : "Invoice",
			fecha : "Date",
			identificacion : "Identification",
			proveedor : "Name",
			cantidad : "Invoices",
			pedido : "Order",
			valor : "Amount",
			impuesto0 : "Tax0",
			categoria0 : "Category0",
			impuesto1 : "Tax1",
			categoria1 : "Category1",
			impuesto2 : "Tax2",
			categoria2 : "Category2",
			impuesto : "Taxes",
			valor_total : "Total Amount",
			items : "Items",
			item : "Item",
			descripcion : "Description",
			diferencia_precio : "Price Dif",
			diferencia_cantidad : "Amount Dif",
			diferencia_iva : "Iva Dif",
			diferencia_impuesto : "Other Tax Dif",
			diferencia_Total : "Total",
			diferencia_total : "Total Dif",
			valor_fe : "FE Value",
			valor_sap : "SAP Value",
		}
	}
}
},
mounted(){
	let fgl_lider =this.$store.state.userId 
	let fgl_usuario =this.$store.state.userId 

	if	(this.$route.name == "manual") {
		this.opcion=1
	}
	Factura.leaFacturas("consultar",this.opcion,fgl_lider,fgl_usuario)
	.then((res) => {
		this.listFacturasG = res.data.listFacturas
		this.listPaises = res.data.listPaises
	})
	.catch((err) => {
		console.log(err)
	})
	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
	})
	.catch((err) => {
		console.log(err)
	})
	Razon.leaRazones()
	.then((res) => {
		this.listRazonesLeidas = res.data.listRazones
	})
	.catch((err) => {
		console.log(err)
	})
	Estado.leaEstados(false)
	.then((res) => {
		this.listEstados = res.data.listEstados
	})
	.catch((err) => {
		console.log(err)
	})
	Lider.leaLider(this.$store.state.userId)
	.then((res) => {
		this.idLider = res.data.listLiderUsuarios[0].id_lider
	})
	.catch((err) => {
		console.log(err)
	})

},
methods:{
	f_titulo() {
		if	(this.$route.name == "manual") {
			this.opcion=0
			return "CONTABILIZACION MANUAL DE FACTURAS"
		}
		return "SIN INFORMACIÓN "+this.$route.name
	},
	f_titulo_novedad() {
		return "REGISTRO DE NOVEDADES "+this.estado.descripcion
	},
	f_usuario_nombre(id) {
		if	(id === undefined) {
			return "Indefinida"
		}
		const usuario = this.users.find((usuario) => usuario.id == id)
		if	(usuario == undefined) {
			return "No definido "+id
		}
		return usuario.name
	},
	f_actualiza_contab(inicio) {
		if	(this.estado.contabiliza == true) {
			if	(this.factura.documento_contable == undefined ||
				this.factura.documento_contable.length<=2) {
				this.$toast.error("Falta documento Contable")
				return
			}
		}
		if	(this.factura.pedido == undefined) {
			this.$toast.error("Falta documento de Compra")
			return
		}
		if	(inicio == true) {
			this.factura.razon_estado=-1
		} else {
			const razon = this.listRazones.find((r_razon) => r_razon.razon==this.factura.razon_estado)
			this.factura.estado=razon.estado
			if	(this.estado.seguimiento == true) {
				this.novedad.pais = this.pais
				this.novedad.tipo_novedad = this.factura.estado
				this.novedad.fecha_novedad = new Date()
				this.novedad.pedido=this.factura.pedido
				this.novedad.remision=this.factura.remision
				this.novedad.documento=this.factura.documento
				this.novedad.factura=this.factura.factura
				this.novedad.archivo="MANUAL"
				this.novedad.documento_contable=this.factura.documento_contable
				this.novedad.valor_total=this.factura.valor_total
				this.novedad.razon_social=this.factura.nombre
				this.novedad.rut_proveedor=this.factura.identificacion
				this.novedad.id_lider=this.factura.id_lider
				this.novedad.id_usuario=this.factura.id_usuario
				this.novedad.llave=this.factura.llave
				this.muestreDetalleFactura=false
				this.novedad_detalle.forEach((r_novedad,idx) => {
					this.novedad_detalle[idx].pais = this.novedad.pais
					this.novedad_detalle[idx].tipo_novedad = this.novedad.tipo_novedad
					this.novedad_detalle[idx].fecha_novedad=this.novedad.fecha_novedad
					this.novedad_detalle[idx].pedido=this.novedad.pedido
					this.novedad_detalle[idx].remision=this.novedad.remision
					this.novedad_detalle[idx].documento=this.novedad.documento
					this.novedad_detalle[idx].factura=this.novedad.factura
					this.novedad_detalle[idx].archivo=this.novedad.archivo
					this.novedad_detalle[idx].valor_factura=this.novedad.valor_total
					this.novedad_detalle[idx].razon_social=this.novedad.razon_social
					this.novedad_detalle[idx].rut_proveedor=this.novedad.rut_proveedor
					this.novedad_detalle[idx].llave=this.novedad.llave
					this.novedad_detalle[idx].documento_contable=this.novedad.documento_contable
					this.novedad_detalle[idx].id_lider=this.novedad.id_lider
					this.novedad_detalle[idx].id_usuario=this.novedad.id_usuario
					this.novedad_detalle[idx].estado=null
					this.novedad_detalle[idx].u_crea=this.$store.state.userId 
				})
			} else {
				this.observaciones=''
				this.estado={}
				this.novedad_detalle=[]
			}
			if	(this.estado.contabiliza == false) {
				this.factura.documento_contable=''
			}
		}
			

		var v_factura = {
			factura : this.factura.factura,
			archivo : this.factura.archivo,
			inicia_contab: this.factura.inicia_contab,
			u_crea: this.$store.state.userId,
			documento_contable : this.factura.documento_contable,
			observaciones : this.observaciones,
			r_factura : this.factura,
			novedad_detalle : this.novedad_detalle
		}
		Factura.grabeManualContab(inicio,this.factura.razon_estado,this.factura.estado,v_factura)
		.then(() => {
			if	(inicio) {
				this.$toast.success("Contabilizacion Iniciada")
			} else {
				this.$toast.success("Estado Cambiado")
			}
			this.muestreDetalleFactura=false
			this.contabilizaFactura=false
			this.fgl_novedad=false
		})
		.catch((err) => {
			console.log(err)
			this.$toast.error("Problema al cambiar estado")
		})
		this.f_inicie_contab_documentos(this.factura.identificacion)
	},
	f_pide_adicional() {
		this.grabar=true
		this.novedades = true
		this.f_razon(this.factura.razon_estado)
		if	(this.estado.contabiliza == true || 
			this.estado.observaciones == true) {
			this.adicional=true
		} else {
			this.adicional = false
			this.novedades = true
		}
		if	(this.estado.contabiliza == false && 
			this.estado.observaciones == true) {
			this.novedades=true
		}
	},
	f_estado(estado) {
		if	(estado == null || estado == undefined) {
			return ""
		}
		const v_estado = this.listEstados.find((r_estado) => r_estado.estado == estado)
		if	(v_estado == undefined || v_estado == null) {
			return estado
		}
		return v_estado.descripcion
	},

	f_razon(razon) {
		if	(this.listRazones.length==0) {
			this.listRazones=this.listRazonesLeidas
		}
		const v_razon = this.listRazones.find((r_razon) => r_razon.razon == razon)
		this.estado = this.listEstados.find((r_estado) => r_estado.estado == v_razon.estado)
	},
	f_verifique_doc_contable(p_doc_contable) {
		var fgl_error = false
		if	(p_doc_contable.length == 1) {
			if	(p_doc_contable != "3" &&
				p_doc_contable != "8" &&
				p_doc_contable != "1" &&
				p_doc_contable != "2") {
				fgl_error = true
			}
		}
		if	(p_doc_contable.length == 2) {
			if	(p_doc_contable != "39" &&
				p_doc_contable != "87" &&
				p_doc_contable != "18" &&
				p_doc_contable != "21") {
				fgl_error = true
			}
		}
		if	(p_doc_contable.length > 2) {
			if	(p_doc_contable.substr(0,2) != "39" &&
				p_doc_contable.substr(0,2) != "87" &&
				p_doc_contable.substr(0,2) != "18" &&
				p_doc_contable.substr(0,2) != "21") {
				fgl_error = true
			}
		}
		if	(fgl_error == true) {
			this.factura.documento_contable='39'
			this.$toast.success("Documento debe comenzar por Facturas(39,87) NC/ND(18,21)")
		} else {
			this.novedades=true
		}
	},
	f_diferencias_total() {
		let v_val_diferencia=0
		this.novedad_detalle.forEach((novedad) => {
			if	(parseInt(novedad.cantidad_fe)>parseInt(novedad.cantidad_sap)) {
				let cantidad = parseInt(novedad.cantidad_fe)-
					parseInt(novedad.cantidad_sap)
				let precio_fe=novedad.precio_fe
				precio_fe=precio_fe.replace(',','.')
				let precio_unitario = parseFloat(precio_fe)/
					parseInt(novedad.cantidad_fe)
				let v_valor=parseFloat(precio_unitario)*
					parseInt(cantidad)
				v_val_diferencia=parseFloat(v_val_diferencia)+
					parseFloat(v_valor)
			}
		})
		return v_val_diferencia.toFixed(2)
	},
	f_formato_fecha(fecha) {
		if	(fecha == undefined) {
			return "Fecha"
		}
		const v_dia=fecha.substr(8,2)
		const v_mes=fecha.substr(5,2)
		const v_año=fecha.substr(0,4)
		fecha=v_dia+'.'+v_mes+'.'+v_año
		return fecha
	},
	f_razones_leidas() {
		this.listRazones=[]
		this.listRazonesLeidas.forEach((razon) => {
			const v_estado = this.listEstados.find((r_estado) => r_estado.estado == razon.estado && r_estado.contabiliza == 1
		)
			if	(v_estado == undefined) {
				this.listRazones.push(razon)
			}
		})
	},
	f_valida_factura(r_factura_control) {
		if	(r_factura_control == undefined) {
			return
		}
		this.listControl = r_factura_control

		this.fgl_muestraDetalle=false
		this.muestreDetalleFactura=false
		this.factura.pais = this.listControl.pais
		this.factura.documento = this.listControl.tipo_cp=="Factura" ? "FAC" : "NC"
		this.factura.factura = this.listControl.factura
		this.factura.fecha_factura = this.listControl.fecha
		this.factura.identificacion = this.listControl.identificacion
		this.factura.nombre=this.listControl.razon_social
		this.factura.valor_total=this.listControl.total_cp.replace('.',',')
		this.factura.impuesto_total=this.listControl.ivg_ipm_dg.replace('.',',')
		this.factura.valor=parseFloat(this.listControl.total_cp)-parseFloat(this.listControl.ivg_ipm_dg)
		this.factura.valor=this.factura.valor.toFixed(2)
		this.factura.valor=this.factura.valor.replace('.',',')
		this.factura.items=1
		this.factura.archivo="MANUAL"
		this.factura.id_archivo=1
		this.factura.xml="MANUAL"

		this.factura.llave=this.listControl.car_sunat
		this.factura.detraccion=this.listControl.detraccion
		this.factura.id_usuario=this.$store.state.userId 
		this.factura.id_lider=this.idLider
		this.listRazones=this.listRazonesLeidas
		this.muestreDetalleFactura=true
		this.factura.inicia_contab = new Date()
	},
	f_inicie_contab() {
		this.fgl_muestraDetalle= true
		this.muestreDetalleFactura = false
		this.factura={}
		this.novedad={}
		this.novedad_detalle=[]
		this.estado = ''
		this.grabar = false
		this.observaciones = ''
	},
	f_inicie_contab_documentos(identificacion) {
		this.fgl_muestraDetalle= true
		this.muestreDetalleFactura = false
		this.factura={}
		this.novedad={}
		this.novedad_detalle=[]
		this.estado = ''
		this.grabar = false
		this.observaciones = ''
		setTimeout(() => {
			this.listFacturasProveedor=[]
			Factura.leaManualFacturasProveedor(this.pais,identificacion) 
			.then((res) => {
				this.listFacturasProveedor = res.data.listFacturasProveedor
				if	(this.listFacturasProveedor.length == 0) {
					this.$toast.error("No existe informacion manual a contabilizar")
				}
			})
		},1000)
	},
	f_pide_novedades() {
		this.muestreDetalleFactura=false
		this.fgl_novedades=true
	},
	f_adiciona_novedad() {
		this.nuevaNovedad = true
	},
	f_agrega_novedad() {
		if	(this.novedad.item == undefined ||
			this.novedad.descripcion == undefined ||
			this.novedad.cantidad_fe == undefined ||
			this.novedad.precio_fe == undefined ||
			this.novedad.iva_fe == undefined ||
			this.novedad.impuesto_adicional_fe == undefined ||
			this.novedad.cantidad_sap == undefined ||
			this.novedad.precio_sap == undefined ||
			this.novedad.iva_sap == undefined) {
			this.$toast.error("Todos los campos son aobligatorios")
			return
		}
		this.nuevaNovedad = false
		this.novedad_detalle.push(this.novedad)
		this.novedad={}
	},
	f_acepta_novedades() {
		this.fgl_novedades=false
		this.grabar=true
		this.muestreDetalleFactura=true
		this.factura.diferencia=this.f_diferencias_total()
	},
	f_carga_facturas() {
		this.listFacturas=[]
		Factura.leaManualFacturas(this.pais,this.$store.state.userId) 
		.then((res) => {
			this.listFacturas = res.data.listFacturas
			if	(this.listFacturas.length == 0) {
				this.$toast.error("No existe informacion manual a contabilizar")
			} else {
				this.fgl_muestraProveedores = true
			}
		})
		.catch((err) => {
			console.log(err)
		})
	},
	f_selecciona_facturas(r_proveedor) {
		this.listFacturasProveedor=[]
		Factura.leaManualFacturasProveedor(this.pais,r_proveedor.identificacion) 
		.then((res) => {
			this.listFacturasProveedor = res.data.listFacturasProveedor
			if	(this.listFacturasProveedor.length == 0) {
				this.$toast.error("No existe informacion manual a contabilizar")
			} else {
				this.fgl_muestraProveedores = false
				this.fgl_muestraDetalle = true
			}
		})
		.catch((err) => {
			console.log(err)
		})
	},
}

}
</script>

<style>

</style>
